/**
 * Silverly - Newsletter Intention Popup
 * Manages modal display, validation, Shopify customer submission, intention tagging, and coupon copying.
 */

(function () {
  'use strict';

  function initSilverlyPopup() {
    const overlay = document.getElementById('SlvIntentionModalOverlay');
    if (!overlay) return;

    const modalCard = overlay.querySelector('.slv-intention-modal-card');
    const closeBtn = overlay.querySelector('.slv-intention-modal-close');
    const declineBtn = overlay.querySelector('.slv-intention-decline');
    const continueBtn = overlay.querySelector('#SlvIntentionContinueShopping');
    const form = overlay.querySelector('#SlvIntentionForm');
    const emailInput = overlay.querySelector('#SlvIntentionEmail');
    const submitBtn = overlay.querySelector('#SlvIntentionSubmitBtn');
    const emailError = overlay.querySelector('#SlvIntentionEmailError');
    const intentionError = overlay.querySelector('#SlvIntentionOptionError');
    const couponBox = overlay.querySelector('#SlvIntentionCouponBox');
    const copyBtn = overlay.querySelector('#SlvIntentionCopyBtn');
    const couponCodeEl = overlay.querySelector('#SlvIntentionCouponCode');
    const copyToast = overlay.querySelector('#SlvIntentionCopyToast');

    const floatingLauncher = document.getElementById('SlvFloatingLauncher');
    const launcherClose = document.getElementById('SlvFloatingLauncherClose');
    const bottomReminder = document.getElementById('SlvBottomReminderBar');
    const reminderCoupon = document.getElementById('SlvReminderCoupon');
    const reminderClose = document.getElementById('SlvReminderClose');

    // Config options from data attributes
    const delaySeconds = parseInt(overlay.getAttribute('data-delay') || '3', 10);
    const expireDays = parseInt(overlay.getAttribute('data-expire-days') || '7', 10);
    const discountCode = overlay.getAttribute('data-discount-code') || 'YOUR_10_PERCENT_DISCOUNT_CODE';

    const STORAGE_KEY_SUBSCRIBED = 'silverly_popup_subscribed';
    const STORAGE_KEY_DISMISSED = 'silverly_popup_dismissed_until';
    const STORAGE_KEY_INTENTION = 'silverly_saved_intention';
    const STORAGE_KEY_LAUNCHER_CLOSED = 'silverly_launcher_dismissed';
    const STORAGE_KEY_REMINDER_CLOSED = 'silverly_reminder_dismissed';

    // Check storage status
    const isSubscribed = localStorage.getItem(STORAGE_KEY_SUBSCRIBED) === 'true';
    const dismissedUntil = localStorage.getItem(STORAGE_KEY_DISMISSED);
    const isDismissed = dismissedUntil && Date.now() < parseInt(dismissedUntil, 10);

    // Initial State & Auto Trigger
    if (isSubscribed) {
      // If already subscribed, hide launcher and show reminder bar if not closed
      if (floatingLauncher) floatingLauncher.classList.add('is-hidden');
      if (bottomReminder && sessionStorage.getItem(STORAGE_KEY_REMINDER_CLOSED) !== 'true') {
        bottomReminder.classList.remove('is-hidden');
      }
    } else if (!isDismissed) {
      setTimeout(function () {
        openModal();
      }, delaySeconds * 1000);
    }

    // Modal Control Functions
    function openModal() {
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      if (floatingLauncher) floatingLauncher.classList.add('is-hidden');
    }

    function closeModal() {
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';

      // If dismissed without subscribing, set temporary dismissal cookie/storage
      if (!isSubscribed) {
        const dismissDuration = expireDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(STORAGE_KEY_DISMISSED, (Date.now() + dismissDuration).toString());
        if (floatingLauncher && sessionStorage.getItem(STORAGE_KEY_LAUNCHER_CLOSED) !== 'true') {
          floatingLauncher.classList.remove('is-hidden');
        }
      } else {
        if (bottomReminder && sessionStorage.getItem(STORAGE_KEY_REMINDER_CLOSED) !== 'true') {
          bottomReminder.classList.remove('is-hidden');
        }
      }
    }

    function showSuccessView() {
      modalCard.classList.add('is-success');
    }

    // Event Listeners for Closing Modal
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', closeModal);
    }
    if (continueBtn) {
      continueBtn.addEventListener('click', closeModal);
    }

    // Overlay background click
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeModal();
      }
    });

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
        closeModal();
      }
    });

    // Form Submission & Validation
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Clear previous error states
        if (emailError) emailError.classList.remove('is-visible');
        if (intentionError) intentionError.classList.remove('is-visible');
        if (emailInput) emailInput.classList.remove('has-error');

        const email = emailInput ? emailInput.value.trim() : '';
        const selectedRadio = form.querySelector('input[name="intention"]:checked');
        const selectedIntention = selectedRadio ? selectedRadio.value : '';

        // Validation
        let hasError = false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email || !emailRegex.test(email)) {
          hasError = true;
          if (emailInput) emailInput.classList.add('has-error');
          if (emailError) {
            emailError.textContent = 'Please enter a valid email address.';
            emailError.classList.add('is-visible');
          }
        }

        if (!selectedIntention) {
          hasError = true;
          if (intentionError) {
            intentionError.textContent = 'Please select an intention.';
            intentionError.classList.add('is-visible');
          }
        }

        if (hasError) return;

        // Prevent duplicate submissions
        if (submitBtn.disabled) return;
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');

        const hiddenTagsInput = form.querySelector('#SlvIntentionTags');
        if (hiddenTagsInput) {
          hiddenTagsInput.value = selectedIntention;
        }

        // Prepare Shopify Customer Form payload
        const formData = new FormData();
        formData.append('form_type', 'customer');
        formData.append('utf8', '✓');
        formData.append('contact[email]', email);
        formData.append('contact[tags]', selectedIntention);
        formData.append('contact[note][Intention]', selectedIntention);

        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            return response.text();
          })
          .then(function () {
            // Save state
            localStorage.setItem(STORAGE_KEY_SUBSCRIBED, 'true');
            localStorage.setItem(STORAGE_KEY_INTENTION, selectedIntention);

            // Switch to Success View
            submitBtn.classList.remove('is-loading');
            submitBtn.disabled = false;
            showSuccessView();

            if (floatingLauncher) floatingLauncher.classList.add('is-hidden');
            if (bottomReminder && sessionStorage.getItem(STORAGE_KEY_REMINDER_CLOSED) !== 'true') {
              bottomReminder.classList.remove('is-hidden');
            }
          })
          .catch(function (error) {
            console.error('Subscription error:', error);
            // Even if network error occurs, grant access to the discount code gracefully
            localStorage.setItem(STORAGE_KEY_SUBSCRIBED, 'true');
            localStorage.setItem(STORAGE_KEY_INTENTION, selectedIntention);
            submitBtn.classList.remove('is-loading');
            submitBtn.disabled = false;
            showSuccessView();
          });
      });
    }

    // Email Input auto clear error on type
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        emailInput.classList.remove('has-error');
        if (emailError) emailError.classList.remove('is-visible');
      });
    }

    // Radio auto clear error on change
    const radios = form ? form.querySelectorAll('input[name="intention"]') : [];
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (intentionError) intentionError.classList.remove('is-visible');
        const hiddenTagsInput = form.querySelector('#SlvIntentionTags');
        if (hiddenTagsInput) {
          hiddenTagsInput.value = radio.value;
        }
      });
    });

    // Copy to Clipboard logic
    function copyCouponCode() {
      const code = couponCodeEl ? couponCodeEl.textContent.trim() : discountCode;
      if (!code) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          showCopiedToast();
        }).catch(function () {
          fallbackCopyText(code);
        });
      } else {
        fallbackCopyText(code);
      }
    }

    function fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        showCopiedToast();
      } catch (err) {
        console.error('Fallback copy failed', err);
      }
      document.body.removeChild(textArea);
    }

    function showCopiedToast() {
      if (copyToast) {
        copyToast.classList.add('is-show');
        setTimeout(function () {
          copyToast.classList.remove('is-show');
        }, 2200);
      }
    }

    if (couponBox) {
      couponBox.addEventListener('click', copyCouponCode);
    }
    if (copyBtn) {
      copyBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        copyCouponCode();
      });
    }

    // Floating Launcher Events
    if (floatingLauncher) {
      floatingLauncher.addEventListener('click', function (e) {
        if (e.target.closest('#SlvFloatingLauncherClose')) return;
        if (localStorage.getItem(STORAGE_KEY_SUBSCRIBED) === 'true') {
          showSuccessView();
        }
        openModal();
      });
    }

    if (launcherClose) {
      launcherClose.addEventListener('click', function (e) {
        e.stopPropagation();
        if (floatingLauncher) floatingLauncher.classList.add('is-hidden');
        sessionStorage.setItem(STORAGE_KEY_LAUNCHER_CLOSED, 'true');
      });
    }

    // Bottom Reminder Bar Events
    if (reminderCoupon) {
      reminderCoupon.addEventListener('click', function () {
        const code = discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            alert('Discount code ' + code + ' copied to clipboard!');
          });
        }
      });
    }

    if (reminderClose) {
      reminderClose.addEventListener('click', function () {
        if (bottomReminder) bottomReminder.classList.add('is-hidden');
        sessionStorage.setItem(STORAGE_KEY_REMINDER_CLOSED, 'true');
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSilverlyPopup);
  } else {
    initSilverlyPopup();
  }

  // Support Shopify theme editor reloads
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('#SlvIntentionModalOverlay')) {
      initSilverlyPopup();
    }
  });
})();
